import brand from './brand/store';
import property from './property/store';
import filter from './filter/store';
import dictionary from './dictionary/store';
import keyword from './keyword/store';
import option from './option/store';

export default {
  namespaced: true,
  modules: { brand, property, filter, dictionary, keyword, option },
};
